import { useContext, React } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { UserContext } from "../context/UserContext.component";

export const PrivateRoutes = () => {
  const {
    state: { user },
  } = useContext(UserContext);

  return user ? <Outlet /> : <Navigate to="/login" />;
};
